import { render, staticRenderFns } from "./FormRequirementGroupSelect.vue?vue&type=template&id=52a89180&scoped=true&"
import script from "./FormRequirementGroupSelect.vue?vue&type=script&lang=js&"
export * from "./FormRequirementGroupSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormRequirementGroupSelect.vue?vue&type=style&index=0&id=52a89180&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a89180",
  null
  
)

export default component.exports